export default "__VITE_ASSET__HUnB8A5M__"